<script lang="ts">
import { defineComponent, PropType, computed, useSlots, } from 'vue'
import ContentsTab from '@/components/solutions/ContentsTab.vue'

export default defineComponent({
  name: 'SolutionPageWrapper',

  components: {
    ContentsTab,
  },

  props: {
    /**
     * solution の id
     */
    id: {
      type: [Number, String],
      default: undefined,
    },

    currentTabKey: {
      type: String as PropType<'index' | 'documents' | 'videos'>,
      default: 'index',
    },

    tabOption: {
      type: Object as PropType<{
        hasDocuments: boolean,
        hasVideos: boolean,
      }>,
      required: true,
    },
  },
  setup() {
    const slots = useSlots()
    const hasDescription = computed(() => !!slots.description)
    const hasPagination = computed(() => !!slots.pagination)

    return {
      // computed
      hasDescription,
      hasPagination,
    }
  },
})
</script>

<template>
  <section class="section">
    <div
      v-if="id"
      class="l-unit__solution">
      <div class="l-unit__solution--header">
        <ContentsTab
          :id="id"
          :current-tab-key="currentTabKey"
          :tab-option="tabOption" />
      <!-- /.l-unit__solution header --></div>

      <div
        v-if="hasDescription"
        class="l-unit__solution--description">
        <slot name="description" />
      <!-- /.l-unit__solution description --></div>

      <div
        v-if="hasPagination"
        class="l-unit__solution--action">
        <slot name="pagination" />
      <!-- /.l-unit__solution action --></div>
    <!-- /.l-unit__solution --></div>

    <p
      v-else
      class="p u-text__center">
      製品 ID が取得できませんでした。
    </p>
  </section>
</template>

<style lang="sass" scoped>
// layout
.l-unit__solution
  & &--header
    margin-bottom: 24px

    &:last-child
      margin-bottom: 0

  & &--action
    margin-top: 24px
    padding-top: 1em
    border-top: 1px solid $border-x-light-gray

    &:first-child
      margin-top: 0
      padding-top: 0
</style>
